<div class="stage-progress-container" [class.compact]="compact">
  <div class="progress-header" *ngIf="!compact">
    <h5>表單填寫進度</h5>
    <div class="progress-summary">
      {{ currentStageIndex + 1 }} / {{ stages.length }} 階段
    </div>
  </div>

  <div class="progress-bar-container">
    <div class="progress-bar-background">
      <div class="progress-bar-fill" [style.width.%]="getProgressPercentage()"></div>
    </div>
  </div>

  <div class="stages-container">
    <div class="stage-item" 
         *ngFor="let stage of stages; let i = index"
         [class]="getStageStatus(i)">
      <div class="stage-indicator">
        <div class="stage-number" *ngIf="getStageStatus(i) !== 'completed'">{{ i + 1 }}</div>
        <i class="fas fa-check" *ngIf="getStageStatus(i) === 'completed'"></i>
      </div>
      <div class="stage-info" *ngIf="!compact">
        <div class="stage-name">{{ stage.name }}</div>
        <div class="stage-departments" *ngIf="stage.requiredDepartments.length > 0">
          {{ stage.requiredDepartments.join(', ') }}
        </div>
      </div>
    </div>
  </div>

  <div class="current-stage-detail" *ngIf="!compact && stages[currentStageIndex]">
    <div class="detail-card">
      <h6>目前階段：{{ stages[currentStageIndex].name }}</h6>
      <p *ngIf="stages[currentStageIndex].description">
        {{ stages[currentStageIndex].description }}
      </p>
      <div class="stage-meta" *ngIf="stages[currentStageIndex].requiredDepartments.length > 0">
        <strong>負責部門：</strong>
        <span class="department-list">{{ stages[currentStageIndex].requiredDepartments.join(', ') }}</span>
      </div>
    </div>
  </div>
</div>